import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import "./Dialog.css";
import UploadDialog from "../UploadPic/UploadDialog";
import Iframe from "react-iframe";
import { srcImagesFile } from "../../utilities/FileUtil";

const showContent = (textContent) => {
    let text = "";
    if (textContent) {
        if (textContent.indexOf("สำเร็จ") !== -1 || textContent.indexOf("บันทึกสำเร็จ") !== -1) {
            text = (
                <div style={{ textAlign: "center" }}>
                    <i className="pi pi-check-circle" style={{ fontSize: "larger", color: "green" }}></i>
                    <label style={{ marginLeft: "5px" }}>{textContent}</label>
                </div>
            );
        } else if (textContent === "มีข้อผิดพลาด" || textContent.indexOf("ผิดพลาด") !== -1) {
            text = (
                <div style={{ textAlign: "center" }}>
                    <i className="pi pi-times-circle" style={{ fontSize: "larger", color: "red" }}></i>
                    <label style={{ marginLeft: "5px" }}>{textContent}</label>
                </div>
            );
        } else {
            text = (
                <div style={{ textAlign: "center" }}>
                    <label style={{ whiteSpace: "pre-wrap" }}>{textContent}</label>
                </div>
            );
        }
    }

    return text;
};

export const DialogDelete = ({ header, visible, width, footer, onHide, textContent }) => {
    return (
        <Dialog
            // header={header}
            visible={visible}
            style={{ width: "400px" }}
            className="p-fluid p-dialog-header-modify"
            modal
            footer={footer}
            onHide={onHide}
        >
            {/* <div className="confirmation-content" style={{ paddingTop: "0em" }}>
                <h6 style={{ margin: "0px", color: "#625f5f" }}>{textContent}</h6>
            </div> */}
            <p>
                <h5 style={{ marginBottom: "20", marginTop: 10, marginLeft: 20, color: "#625f5f" }}>{textContent}</h5>
            </p>
        </Dialog>
    );
};

export const DialogConfirm = ({ header, visible, footer, onHide, textContent }) => {
    return (
        <Dialog
            //header={header}
            visible={visible}
            style={{ width: "400px" }}
            modal
            footer={footer}
            onHide={onHide}
            // position='top-right'
            className="p-fluid p-dialog-header-modify"
        >
            <p>
                <h5 style={{ margin: "5px", color: "#625f5f", textAlign: "left" }}>{showContent(textContent)}</h5>
            </p>
        </Dialog>
    );
};

export const DialogConfirm_2 = ({ header, visible, footer, onHide, textContent }) => {
    return (
        <Dialog
            //header={header}
            visible={visible}
            style={{ width: "400px" }}
            modal
            footer={footer}
            onHide={onHide}
            // position='top-right'
            className="p-fluid p-dialog-header-modify"
        >
            <p>
                <h5 style={{ margin: "5px", color: "#625f5f", textAlign: "left" }}>{textContent}</h5>
            </p>
        </Dialog>
    );
};

export const DialogWarning = ({ header, visible, width, onHide, textContent, btnOk, btnCancle }) => {
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "center" }}>
                <Button label="ยกเลิก" icon="pi pi-times" onClick={() => btnCancle()} style={{ backgroundColor: "#607D8B", color: "#ffffff" }} className="p-button p-button-secondary" />
                <Button label="ตกลง" icon="pi pi-check" onClick={() => btnOk()} className="p-button p-button-success" />
            </div>
        );
    };

    return (
        <Dialog blockScroll={true} header={header} visible={visible} modal style={{ width: "350px", height: "180px" }} contentStyle={{ marginTop: "15px" }} className="p-fluid" footer={renderFooter()} onHide={onHide}>
            <div className="confirmation-content" style={{ paddingTop: "0em" }}>
                <h5 style={{ margin: "5px", color: "#625f5f" }}>{textContent}</h5>
            </div>
        </Dialog>
    );
};

export const DialogShow_2 = ({ header, visible, onHide, textContent, btnCancle }) => {
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "center" }}>
                <Button label="ปิด" icon="pi pi-times" onClick={() => btnCancle()} style={{ backgroundColor: "#607D8B", color: "#ffffff" }} className="p-button p-button-secondary" />
            </div>
        );
    };
    return (
        <Dialog
            blockScroll={true}
            // header={header}
            visible={visible}
            modal
            style={{ width: "450px" }}
            className="p-fluid p-dialog-header-modify"
            footer={renderFooter()}
            onHide={onHide}
            // position='top-right'
        >
            <div style={{ paddingTop: "10px", textAlign: "left" }}>
                <h5 style={{ margin: "5px", color: "#625f5f" }}>{showContent(textContent)}</h5>
            </div>
        </Dialog>
    );
};

export const DialogShow = ({ header, visible, onHide, textContent, btnCancle }) => {
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button label="ตกลง" icon="pi pi-check" onClick={() => btnCancle()} style={{ width: 120 }} className="p-button-success" />
            </div>
        );
    };

    return (
        <Dialog
            blockScroll={true}
            // header={header}
            visible={visible}
            modal
            style={{ width: "450px" }}
            className="p-fluid p-dialog-header-modify"
            footer={renderFooter()}
            onHide={onHide}
            // position='top-right'
        >
            <div style={{ paddingTop: "10px", textAlign: "left" }}>
                <h5 style={{ margin: "5px", color: "#625f5f" }}>{showContent(textContent)}</h5>
            </div>
        </Dialog>
    );
};

export const DialogUpload = ({ dialog, setDialog, dataFile, setDataFile, onSaveFile, typeFile }) => {
    return (
        <>
            <UploadDialog dialog={dialog} setDialog={setDialog} dataFile={dataFile} setDataFile={setDataFile} onSaveFile={onSaveFile} typeFile={typeFile} />
        </>
    );
};

export const DialogOpenReport = ({ header, dialog, setDialog }) => {
    return (
        <>
            <Dialog
                header={header ? header : "รายงาน"}
                visible={dialog.open}
                blockScroll={true}
                // style={{ width: "auto" }}
                style={{ width: "100vw" }}
                maximized={true}
                maximizable={true}
                onHide={() => setDialog({ open: false, pdfURL: null })}
            >
                <div className="confirmation-content" style={{ paddingTop: "0em" }}>
                    <Iframe url={dialog.pdfURL} width="100%" height={window.innerHeight - 110} display="initial" position="relative" />
                </div>
            </Dialog>
        </>
    );
};

export function DialogViewPic({ dialog, setDialogPic, data }) {
    return (
        <Dialog header="รูปถ่าย" visible={dialog.dialog} style={{ width: "50vw" }} className="p-fluid ___widthDialog" onHide={() => setDialogPic({ dialog: false, show: false })} blockScroll={true} maximizable={true}>
            {dialog && dialog.show === true ? <img {...srcImagesFile(data)} width="100%" alt="รูปถ่าย" /> : null}
        </Dialog>
    );
}

export function DialogViewPic_2({ dialog, setDialogPic, data }) {
    return (
        <Dialog header="รูปถ่าย" visible={dialog.dialog} style={{ width: "50vw" }} className="p-fluid ___widthDialog" onHide={() => setDialogPic({ dialog: false, show: false })} blockScroll={true} maximizable={true}>
            <img {...srcImagesFile(data)} width="100%" alt="รูปถ่าย" />
        </Dialog>
    );
}

export function DialogViewPicBase64({ dialog, setDialogPic, data }) {
    return (
        <Dialog header="รูปถ่าย" visible={dialog.dialog} style={{ width: "50vw" }} className="p-fluid ___widthDialog" onHide={() => setDialogPic({ dialog: false, show: false })} blockScroll={true} maximizable={true}>
            {dialog && dialog.show === true ? <img src={data} width="100%" alt="รูปถ่าย" /> : null}
        </Dialog>
    );
}

export const DialogTimeOut = ({ visible, onHide, textContent, btnCancle }) => {
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "center" }}>
                <Button label="ออกจากระบบ" icon="pi pi-sign-out" onClick={() => btnCancle()} style={{ width: 150 }} className="p-button-warning" />
            </div>
        );
    };

    return (
        <Dialog
            blockScroll={true}
            // header={header}
            visible={visible}
            modal
            style={{ width: "500px" }}
            className="p-fluid p-dialog-header-modify"
            footer={renderFooter()}
            onHide={onHide}
            closable={false}
        >
            <div style={{ paddingTop: "10px", textAlign: "center" }}>
                <h5 style={{ margin: "5px", color: "#625f5f" }}>{showContent(textContent)}</h5>
            </div>
        </Dialog>
    );
};
